// @flow

import { Component } from "react";

import LegacyDispatcher from "app/lib/legacyDispatcher";
import Row from "app/components/build/Row";
import BuildRow from "app/components/build/BuildRow";

import BranchStore, { type Branch, type Project } from "app/stores/BranchStore";
import Icon from "app/components/shared/Icon";
import classNames from "classnames";

type Props = {
  branch: Branch,
  project: Project,
  store: BranchStore,
};

// eslint-disable-next-line react/require-optimization
export default class BranchListBranch extends Component<Props> {
  render() {
    const starredClassName = this.props.branch.starred
      ? "better-branch-starred"
      : "better-branch-not-starred";

    return (
      <div
        className={classNames(
          `panel mb4 panel-default better-branch-panel ${starredClassName}`,
          {
            "mb6 border-none depth-150 rounded-1.5 antialiased":
              Features.BuildsFilteringPipelineBuilds,
          },
        )}
        data-branch={this.props.branch.name}
      >
        <div
          className={classNames("panel-heading  flex items-center  ", {
            "bg-slate-100 rounded-top-1.5 charcoal-700":
              Features.BuildsFilteringPipelineBuilds,
          })}
        >
          <div className="flex-auto">
            <h2
              className={classNames("h4  m0 regular ", {
                "line-height-1 flex items-center":
                  Features.BuildsFilteringPipelineBuilds,
              })}
            >
              {Features.BuildsFilteringPipelineBuilds ? (
                <Icon
                  icon="custom/outline/14x/branch"
                  className="mr0.5"
                  style={{ height: 14, width: 14 }}
                />
              ) : (
                <i className="fa fa-code-fork text-muted mr1" />
              )}
              <a
                className={classNames(
                  "no-highlight-link better-branch-panel-name ",
                  {
                    "hover-color-inherit":
                      Features.BuildsFilteringPipelineBuilds,
                  },
                )}
                href={this.props.branch.path}
              >
                {this.props.branch.name}
              </a>
            </h2>
          </div>
          <div className="flex">
            {this.renderStarButton()}
            {this.renderRemoveButton()}
          </div>
        </div>
        {this.props.branch.builds &&
          this.props.branch.builds.map((build) =>
            window.Features.BuildsFilteringPipelineBuilds ? (
              <BuildRow key={build.id} build={build} store={this.props.store} />
            ) : (
              <Row key={build.id} {...build} />
            ),
          )}
      </div>
    );
  }

  renderStarButton() {
    if (this.props.project.permissions.favoriteProject.allowed) {
      if (this.props.branch.starred) {
        return (
          <a
            href="#"
            onClick={this.handleUnstarClick}
            className="better-branch-star-button"
            aria-label={`Favorite ${this.props.branch.name} branch`}
          >
            <i className="fa fa-star" />
          </a>
        );
      }
      return (
        <a
          href="#"
          onClick={this.handleStarClick}
          className="better-branch-star-button"
          aria-label={`Favorite ${this.props.branch.name} branch`}
        >
          <i className="fa fa-star-o" />
        </a>
      );
    }

    return null;
  }

  renderRemoveButton() {
    if (this.props.project.permissions.edit.allowed) {
      return (
        <a
          href="#"
          onClick={this.handleRemoveClick}
          className={classNames("better-branch-remove-button", {
            "hover-color-inherit": Features.BuildsFilteringPipelineBuilds,
          })}
          aria-label={`Remove ${this.props.branch.name} branch`}
        >
          <i className="fa fa-ban" />
        </a>
      );
    }
  }

  handleStarClick = (event: SyntheticMouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    LegacyDispatcher.emit("project_branch:star", {
      project: this.props.project,
      branch: this.props.branch.name,
    });
  };

  handleUnstarClick = (event: SyntheticMouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    LegacyDispatcher.emit("project_branch:unstar", {
      project: this.props.project,
      branch: this.props.branch.name,
    });
  };

  handleRemoveClick = (event: SyntheticMouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (confirm("Remove this branch until new builds are pushed?")) {
      this.props.store.removeBranch(this.props.branch.name);
    }
  };
}
